import React from "react";
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Sector } from "recharts";
import { COLORS } from "../../constants/dashboard";
import { Empty } from "antd";
import { PieSectorDataItem } from "recharts/types/polar/Pie";
const formatterUS = new Intl.NumberFormat("en-US");

const RADIAN = Math.PI / 180;

interface FmPieChartProps {
  data: any[];
  height?: number;
  loading?: boolean;
}

const FmPieChart: React.FC<FmPieChartProps> = ({ data = [], height = 350, loading = false }) => {
  const renderActiveShape = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    payload,
    percent,
    value,
  }: PieSectorDataItem) => {
    const sin = Math.sin(-RADIAN * (midAngle ?? 1));
    const cos = Math.cos(-RADIAN * (midAngle ?? 1));
    const sx = (cx ?? 0) + ((outerRadius ?? 0) + 4) * cos;
    const sy = (cy ?? 0) + ((outerRadius ?? 0) + 4) * sin;
    const mx = (cx ?? 0) + ((outerRadius ?? 0) + 20) * cos;
    const my = (cy ?? 0) + ((outerRadius ?? 0) + 20) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 15;
    const ey = my;
    const textAnchor = cos >= 0 ? "start" : "end";
    return (
      <g>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
        />
        <Sector
          cx={cx}
          cy={cy}
          startAngle={startAngle}
          endAngle={endAngle}
          innerRadius={(outerRadius ?? 0) + 2}
          outerRadius={(outerRadius ?? 0) + 4}
          fill={fill}
        />
        <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} strokeWidth={2} fill="none" />

        <circle cx={ex} cy={ey} r={4} fill={fill} />

        <text
          x={ex + (cos >= 0 ? 8 : -8)}
          y={ey - 4}
          textAnchor={textAnchor}
          fill="#555"
          fontSize={12}
          fontWeight={500}
        >
          {payload?.username}
        </text>

        <text
          x={ex + (cos >= 0 ? 8 : -8)}
          y={ey + 12}
          textAnchor={textAnchor}
          fill={fill}
          fontSize={13}
          fontWeight={700}
        >
          {formatterUS.format(value)} ({payload?.percent}%)
        </text>
      </g>
    );
  };

  if (data.length === 0 && !loading) {
    return <Empty description="No Data" style={{ marginTop: "30px" }} />;
  }

  return (
    <ResponsiveContainer width="100%" height={height}>
      <PieChart style={{ aspectRatio: 1 }}>
        <Pie
          data={data}
          labelLine={false}
          fill="#8884d8"
          dataKey="value"
          nameKey="username"
          isAnimationActive={true}
          outerRadius="60%"
          activeShape={renderActiveShape}
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${entry.username}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Legend iconSize={8} iconType="square" />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default React.memo(FmPieChart);
